import {useFlags as useLDFlags} from 'launchdarkly-react-client-sdk';

export const useFlags = () => {
  const flags = useLDFlags();

  // Rename the LaunchDarkly flag names
  return {
    accountMfaRow: !!flags.accountMfaRow,
    areaQuotaReportIsActive: !!flags.accountAreaQuotaReports,
    deprecateContracts: !!flags.accountDeprecateContracts,
    deprecateContractsProvisioningOnly:
      !!flags.accountDeprecateContractsProvisioningOnly,
    sentinelHubUserLinkingIsActive: !!flags.sentinelHubUserLinkingActive,
    selfServeQuotaReleaseIsActive: !!flags.accountSelfServeQuotaRelease,
    showCustomerAccounts: !!flags.accountShowCustomerAccounts,
    showAllAccounts: !!flags.accountShowAllAccounts,
    migrationWizardAccess: !!flags.accountAccessToMigrationWizard,
    accountShowTaskingCreditsDownloadsReports:
      !!flags.accountShowTaskingCreditsDownloadsReports,
    manageArchiveControl: !!flags.accountManageArchiveControl,
    sqkmUsedConversionWorkaround: !!flags.accountSqkmUsedConversionWorkaround,
    showLedgerHistory: !!flags.accountShowLedgerHistory,
    showAllocationUI: !!flags.accountShowAllocationUi,
    showUsageReversal: !!flags.accountShowUsageReversal,
    newUiToggle: !!flags.accountNewUiToggle,
  };
};

export default useFlags;
